<template>
  <div
    id="comparison-filter"
    @click.stop.prevent
  >
    <v-list dense>
      <v-list-item class="comparison-filter--list">
        <v-list-item-content>
          <v-select
            v-model="operator"
            dense
            filled
            color="muted"
            item-color="muted"
            :height="40"
            :items="operators"
            item-text="name"
            item-value="value"
            style="color: #535353;"
            @click.stop.prevent
          >
            <template v-slot:append>
              <font-awesome-icon
                icon="chevron-up"
                class="ml-5 operator-icon"
              />
            </template>
          </v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="comparison-filter--list">
        <v-list-item-content>
          <v-form
            v-model="isFormValid"
            class="duration-time"
          >
            <v-text-field
              v-model.number.trim="value"
              type="number"
              :height="40"
              placeholder="Number of Guests"
              append-icon=""
              color="muted"
              item-color="muted"
              filled
              @click.stop.prevent
            />
          </v-form>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="apply-btn">
        <v-list-item-content>
          <v-btn
            color="primary"
            :disabled="!isFormValid"
            @click="updateFilter"
          >
            Apply
          </v-btn>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>
<script>
  export default {
    name: 'ComparisonFilter',
    props: {
      filterKey: String,
    },
    data: () => ({
      operator: { name: 'Equal To', value: '=' },
      operators: [
        { name: 'Equal To', value: '=' },
        { name: 'Not Equal To', value: '!=' },
        { name: 'Greater Than', value: '>=' },
        { name: 'Less Than', value: '<=' },
      ],
      value: 0,
      isFormValid: false,
    }),
    methods: {
      updateFilter () {
        const payload = {
          key: this.filterKey,
          operator: this.operator.value,
          value: `${this.value}`,
        }
        this.$emit('apply-comparison-filter', payload)
      },
    },
  }
</script>
<style lang="scss">
#comparison-filter {
  width: 204px;
  height: 182px;
  overflow-y: hidden;
  .theme--light.v-select .v-select__selection--comma {
    color: #535353;
    font-family: "Degular", sans-serif;
    font-size: 16px;
    letter-spacing: 0.62px;
    line-height: 20px;
  }
  .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: unset;
  }
  .operator-icon {
    height: 16px;
    width: 14px;
    color: #535353;
    margin-top: 4px;
  }
  .apply-btn {
    margin-bottom: -10px;
  }
}
.comparison-filter--list {
  min-height: 30px;
  margin-bottom: -10px;
  height: 69px !important;
  &:first-of-type {
    margin-top: -2px;
  }
}
</style>
